module.exports = __webpack_public_path__ + "static/img/btn1.403b8233.png";